import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { useMediaQuery } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

import { useAuth } from "../../context/SecurityContextProvider"
import NavDropDownBtn from './NavDropDownBtn'

export default function StudioNavbar() {
    const { userData } = useAuth()
    const isMobile = useMediaQuery('(max-width:950px)')

    const styles = {
        appBar: {
            backgroundColor: 'primary.main',
            color: 'primary.bg',
            p: 1.4,
        },
        toolbar: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            m: 0,
            fontFamily: 'Catamaran',
        },
        title: {
            display: 'flex',
            justifyContent: 'center',
            letterSpacing: '.1rem',
            color: 'inherit',
            textDecoration: 'none',
            fontSize: '2.2rem',
            fontWeight: 800,
            fontFamily: 'inherit',
            gap: 1,
        },
        dropdownBox: {
            color: 'text.regular',
        }
    }

    return (
        <AppBar position="static" sx={styles.appBar}>
            <Container maxWidth="xl">
                <Toolbar sx={styles.toolbar}>
                    <Typography
                        variant="h5"
                        noWrap
                        component="a"
                        href="/"
                        sx={styles.title}
                    >
                        Vibio
                    </Typography>

                    {/* Desktop */}
                    {!isMobile && (
                        <Box sx={styles.dropdownBox}>
                            <NavDropDownBtn username={`vibio.co/${userData.username}`} />
                        </Box>
                    )}

                    {/* Mobile */}
                    {isMobile && (
                        <NavDropDownBtn username={<MenuIcon />} />
                    )}
                </Toolbar>
            </Container>
        </AppBar>
    )
}
